import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const milelogeldConfig: TSPConfig = {
  key: 'milelogeld',
  name: 'MileLog ELD',
  imageName: 'MileLogELD',
  category: TSPCategory.CUSTOM,
  helpText: 'Please input the Company ID from your MileLog ELD profile.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Company ID',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default milelogeldConfig;
